import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ed635256"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "link_box"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "connect-us"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "phone-icon"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "phone-number"
}, "+44 1315070088", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
import { reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    // 导航集合
    const menuList = reactive([{
      name: "EXCAVATORS",
      path: "/productView",
      query: {}
    }, {
      name: "OTHER PRODUCTS",
      path: "/otherProducts",
      query: {}
    }, {
      name: "FINANCE",
      path: "/FinanceView",
      query: {}
    }, {
      name: "SERVICE",
      path: "/serviceView",
      query: {}
    }, {
      name: "ABOUT US",
      path: "/AboutView",
      query: {}
    }]);
    // 跳转
    const pathIndex = ref("");
    function handleLink(path, query) {
      if (router.currentRoute.value.name == 'newInquiry') {
        return;
      }
      window?.gtag_click_all && window.gtag_click_all(1);
      router.push({
        path,
        query
      });
    }
    watch(() => router.currentRoute, newV => {
      pathIndex.value = newV.value.path;
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      return _openBlock(), _createBlock(_component_el_header, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: "logo",
          onClick: _cache[0] || (_cache[0] = $event => handleLink('/', {}))
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList, (item, i) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["menu-item", pathIndex.value == item.path ? 'menu-item-active' : '']),
            key: i,
            onClick: $event => handleLink(item.path, item.query)
          }, _toDisplayString(item.name), 11, _hoisted_2)), [[_vShow, _unref(router).currentRoute.value.name != 'newInquiry']]);
        }), 128))]), _unref(router).currentRoute.value.name != 'newInquiry' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6)) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};